import { createAsyncThunk } from "@reduxjs/toolkit";
import { services } from "../../../../api";
import { InsuranceCompany } from "../../../../interfaces/screens/billing";

export const fetchInsurers = createAsyncThunk<InsuranceCompany[]>(
  "insurers/fetchInsurers",
  async (_, { rejectWithValue }) => {
    try {
      const insurers = await services.insurers.getInsurers();
      return insurers;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

export const addInsurer = createAsyncThunk<
  InsuranceCompany,
  Omit<InsuranceCompany, "id">
>("insurers/addInsurer", async (insurer, { rejectWithValue }) => {
  try {
    const newInsurer = await services.insurers.addInsurer(insurer);
    return newInsurer;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const updateInsurer = createAsyncThunk<
  InsuranceCompany,
  InsuranceCompany
>("insurers/updateInsurer", async (insurer, { rejectWithValue }) => {
  try {
    const updatedInsurer = await services.insurers.updateInsurer(insurer);
    return updatedInsurer;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const deleteInsurer = createAsyncThunk<string, string>(
  "insurers/deleteInsurer",
  async (insurerId, { rejectWithValue }) => {
    try {
      await services.insurers.deleteInsurer(insurerId);
      return insurerId;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
); 